import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { addMinutes, format } from 'date-fns';
import { MaterialModule } from 'src/app/material.module';
import { CustomDatePipe } from 'src/app/pipe/date-format.pipe';
import { DialogComponent } from '../../dialog/confirm.dialog';
import { firstValueFrom } from 'rxjs';
import { tasksServices } from 'src/app/services/tasks.service';
import { ItemComponent } from '../../item/item.component';
import { LeadsManagmentComponent } from 'src/app/leads/leads-managment/leads-managment.component';
import { leadsServices } from 'src/app/services/lead.service';
import { Router } from '@angular/router';
import { ActivityCompletionService } from 'src/app/services/activity-completion.service';
import { ActivityLeadService } from 'src/app/services/lead-activity.servise';

@Component({
  selector: 'app-view-activity',
  standalone: true,
  imports: [MaterialModule, CustomDatePipe, ItemComponent, LeadsManagmentComponent],
  templateUrl: './view-activity.component.html',
  styleUrl: './view-activity.component.scss'
})
export class ViewActivityComponent {
  @ViewChild('dialogContainer') dialogElement!: ElementRef;

  startDate: any;
  endDate: any;
  title: string;
  icon: string;
  leadName: string;
  completed: boolean = false;
  activityTypes: any[] = [];
  allDayStart: any;
  allDayEnd: any;


  constructor(
    public dialogRef: MatDialogRef<ViewActivityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private taskService: tasksServices,
    private leadsService: leadsServices,
    private router: Router,
    private activityCompletionService: ActivityCompletionService,
    private activityLeadService: ActivityLeadService
  ) {
    this.data = data;
    this.startDate = data.start;
    this.endDate = data.end ? data.end : new Date(addMinutes(data.start, data.hourSegments));
    this.title = data.title;
    this.icon = data.type?.icon;
    this.leadName = data.lead?.fullName || ''
    this.completed = data.completed;
    this.activityTypes = data.activityTypes;
    
    // Add null/undefined checks before formatting dates
    this.allDayStart = data.startDate 
      ? format(new Date(data.startDate), 'yyyy-MM-dd') 
      : '';
      
    this.allDayEnd = data.endDate 
      ? format(new Date(data.endDate), 'yyyy-MM-dd') 
      : '';
  }

  async deleteActivity(){
    const header = 'Delete Activity';
    const content = 'Are you sure you want to delete this activity?';
    const confirmed = await this.callDialog(this.data, header, content);

    if (confirmed) {
      this.removeActivity();
    }
  }

  callDialog(event: any, header: string, content: string) {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        header,
        content,
      },
      width: '300px', // Optional: customize dialog size
    });

    return dialogRef.afterClosed().toPromise();
  }

  async removeActivity(){
    const response = await firstValueFrom(this.taskService.delete(this.data.id));
    this.dialogRef.close({type: 'delete'});

  }

  async markCompleted(){
    const result = await this.activityCompletionService.markActivityAsDone(this.data);
    
    if (result) {
      this.dialogRef.close({type: 'mark-complete', result: result});
    }
  }

  onMarkCompletedChange(event: any) {
    // Prevent the checkbox from changing its state
    event.source.checked = this.completed;
    
    // Call the markCompleted method
    this.markCompleted();
  }

  async editActivity(){
    this.dialogRef.close();

    await this.activityLeadService.openActivityOnlyModal({...this.data, hourSegments: this.data.hourSegments, activityTypes: this.activityTypes, users: this.data.users, detailed: true, editMode: true});
  }

  async openLead(){
    // this.dialogRef.close();
    // const response = await firstValueFrom(
    //   this.leadsService.getOne(this.data.lead?.id),
    // );

    // const dialogRef = this.dialog.open(LeadsManagmentComponent, {
    //   position: { bottom: '0', right: '0' },
    //   height: '92vh',
    //   width: '65%',
    //   panelClass: 'right-side-dialog',
    //   enterAnimationDuration: '300ms',
    //   exitAnimationDuration: '300ms',
    //   hasBackdrop: true,
    //   data: { data: response },
    // });
    if(this.data.lead?.id){
      const route = this.router.serializeUrl(
        this.router.createUrlTree(['/leads', 'leads-managment', 'manage', this.data.lead?.id])
      );
      const fullUrl = `${window.location.origin}${route}`;
      window.open(fullUrl, '_blank');
    }
   
  }

}
